import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-deployment-approach',
    templateUrl: './deployment-approach.component.html',
    styleUrls: ['./deployment-approach.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeploymentApproachComponent implements OnInit {
  ASDStandardDeployment!: string;

  
  constructor() { }

  ngOnInit(): void {
    this.ASDStandardDeployment = "STANDARD DEPLOYMENT APPROACH";
  }

}
